import React from 'react';
import { useTranslation } from 'react-i18next';

const InfoSportkampenStages = () => {
    const { t } = useTranslation();

    return (
        <>
            <h1>{t('pages_Info-sportkampen-stages.titel')}</h1>
            <h2>{t('pages_Info-sportkampen-stages.algemeen.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.algemeen.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.slaapkamers.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.slaapkamers.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.keuken.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.keuken.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.cafetaria.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.cafetaria.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.multifunctionele_ruimte.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.multifunctionele_ruimte.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.danszaal.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.danszaal.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.turnhal.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.turnhal.p1')}</p>
            <h2>{t('pages_Info-sportkampen-stages.aanvoer_materiaal.titel')}</h2>
            <p>{t('pages_Info-sportkampen-stages.aanvoer_materiaal.p1')}</p>
        </>
    );
}

export default InfoSportkampenStages;